import { useAppStore } from '@/store/modules/app'
import { emojiName } from '@/components/base/emojiMap'
import ArmsRum from '@arms/rum-browser'
/** 将当前页面绘制成图片 */
/**
 * 将当前页面转换为Canvas图片
 * @param {Object} options 配置选项
 * @param {Function} callback 转换完成后的回调函数，参数为生成的图片数据URL
 * @param {string} [options.format='image/png'] 图片格式，如'image/jpeg', 'image/png'
 * @param {number} [options.quality=0.8] 图片质量(0-1)，仅对JPEG有效
 * @param {boolean} [options.scrollIntoView=true] 是否在截图前将元素滚动到视图
 */
import html2canvas from 'html2canvas'

export const setArms = (userId, name) => {
  if (import.meta.env.VITE_USER_NODE_ENV !== 'production') {
  }
  // 只有生产环境上报
  console.log(`setArms: env: ${import.meta.env.VITE_ARMS_ENV}`)
  // ArmsRum.init({
  //   pid: import.meta.env.VITE_ARMS_PID,
  //   endpoint: import.meta.env.VITE_ARMS_ENDPOINT,
  //   env: import.meta.env.VITE_ARMS_ENV,
  //   user: {
  //     name: userId
  //   },
  //   properties: {
  //     userId: userId,
  //     name: name
  //   }
  // })
}

export const armsSendCustom = (type, name, properties) => {
  if (import.meta.env.VITE_USER_NODE_ENV !== 'production') {
  }
  // try {
  //   ArmsRum.sendCustom({ type, name, properties })
  // } catch (err) {
  //   console.log(err)
  // }
}

export const getnum = num => {
  var aNew
  aNew = num.replace(/^\./, '0.')
  aNew = aNew.replace(/([0-9]+\.[0-9]{2})[0-9]*/, '$1')
  if (aNew >= 1) {
    aNew = aNew.replace(/^[0]+/, '')
    console.log('aNew1', aNew)
  } else {
    aNew = aNew.replace(/^0+\./g, '0.')
    console.log('aNew2', aNew)
  }
  return aNew
}

/* 单位w */
export const exchangeUnit = (num, fixedNum = 1) => {
  num = Math.round(num)
  if (num >= 10000) {
    var digit = num / 10000
    var count = digit.toFixed(6).slice(0, -(6 - fixedNum))
    count = Math.max(count)
    return count + 'w+'
  } else {
    return num
  }
}

/* 单位万 */
export const exchangeUnit2 = (num, fixedNum = 0) => {
  num = Math.round(num)
  if (num >= 10000) {
    var digit = num / 10000
    var count = digit.toFixed(6).slice(0, -(6 - fixedNum))
    count = Math.max(count)
    return count + "<span class='text-12px ml-2px' >万+</span>"
  } else {
    return num
  }
}

// 去掉空格
export const isWhitespace = str => {
  return /^\s*$/.test(str)
}

export const uniqueByKey = (arr, key) => {
  const seen = new Set()
  return arr.filter(item => {
    const serializedKey = JSON.stringify(item[key])
    if (!seen.has(serializedKey)) {
      seen.add(serializedKey)
      return true
    }
    return false
  })
}

// 格式化秒
export const formatSeconds = value => {
  let second = parseInt(value) //  秒
  let minute = 0 //  分
  let hour = 0 //  时
  if (second >= 59) {
    minute = parseInt(second / 60)
    second = parseInt(second % 60)
    if (minute > 59) {
      hour = parseInt(minute / 60)
      minute = parseInt(minute % 60)
      if (hour < 10) {
        hour = '0' + hour
      } // 小时补零
    }
  }
  if (second < 10) {
    second = '0' + second
  } // 秒数补零
  if (minute < 10) {
    minute = '0' + minute
  } // 分钟补零
  let result = '' + second
  result = '' + minute + ':' + result
  if (second <= 3600) {
    hour = 0
  }
  if (hour > 0) {
    result = '' + hour + ':' + result
  }
  return result
}

// 年月日时分秒转换为时间戳
export const timediff = (begin_time, end_time) => {
  let beginTime = new Date(begin_time.replace(/\-/g, '/')).getTime() / 1000
  let endTime = new Date(end_time.replace(/\-/g, '/')).getTime() / 1000
  var starttime = ''
  var endtime = ''
  if (beginTime < endTime) {
    starttime = beginTime
    endtime = endTime
  }
  // 计算天数
  var timediff = endtime - starttime
  return timediff
}

/** 时间戳相加减 */
export const timediffLog = (begin_time, end_time) => {
  var starttime = ''
  var endtime = ''
  if (begin_time < end_time) {
    starttime = begin_time
    endtime = end_time
  }
  // 计算天数
  var timediff = endtime - starttime
  return timediff / 1000
}

// 节流工具
export const throttle = (func, wait) => {
  var args // 存储函数参数
  var previous = 0 // 一开始的默认时间
  return function () {
    var now = new Date() // 获取最新的时间戳
    args = arguments // 获取参数
    // 进行时间戳的判断，如果超出规定时间，则执行
    if (now - previous > wait) {
      func.apply(null, args)
      previous = now
    }
  }
}

/**
 * 防抖函数
 * @param {*} func 函数体
 * @param {*} wait 时间间隔
 * @param {*} immediate 是否立即触发
 * @returns
 */
export const debounceFun = (func, wait, immediate) => {
  let timeout
  return function executedFunction() {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    if (callNow) {
      func.apply(context, args)
    }
    timeout = setTimeout(later, wait)
  }
}

// 金额判断
export const checkCash = val => {
  let reg = new RegExp(
    '(^[1-9]{1}[0-9]*([.]{1}[0-9]{2})$)|(^[0]{1}([.]{1}[0-9]{1}[1-9]{1})$)|(^[0]{1}([.]{1}[1-9]{1}[0-9]{1})$)'
  )

  if (!reg.test(val)) {
    return false
  } else {
    return true
  }
}

/**
 * 将字符串加密输出
 * @param {string} str 要加密的字符串
 * @param {number} num 要显示的数字长度
 * @returns '123***'
 */
export const getEncryptStr = (str, num) => {
  const s = str.slice(0, num)
  const arr = str.slice(num, 9999).split('')
  return s + arr.map(v => '*').join('')
}

/**
 * 将字符串数字转成*
 * @param {string} str 要加密的字符串
 * @returns 'like123-like***'
 */
export const getNumberToStar = str => {
  return str.replace(/\d/g, '*')
}

/**
 * 处理文本消息中的链接消息
 */
// export const getTextUrl = url => {
//   const reg = /http(s)?:\/\/[^\s][\#\&\^\%\$\!\.\_\-\/\*\@A-Za-z0-9]*/gi
//   const linkedText = url.replace(reg, $0 => `<a href="${$0}" target="\_blank">${$0}</a>`)
//   console.log('链接处理', linkedText, url)
//
//   return `<span style="
//            whiteSpace: pre-line;
//           wordBreak: 'break-all;
//            wordWrap: 'break-word"
//        >${linkedText}</span>`
// }

/**
 * 将文本中的微信风格链接替换为HTML超文本（<a>标签）
 * @param {string} messageText - 原始文本内容
 * @param {object} [options={}] - 可选配置项
 * @param {string} [options.target='_blank'] - 超链接打开方式，默认新窗口
 * @param {string} [options.className='wechat-link'] - 超链接自定义类名，方便样式控制
 * @returns {string} 替换后的HTML文本
 */
export const getTextUrl = (messageText, options = {}) => {
  // 默认配置
  const {
    target = '_blank',
    className = 'wechat-link'
  } = options;

  // 匹配微信消息中链接的正则（和之前识别逻辑一致）
  const urlRegex = /(https?:\/\/|www\.)(?:[^\s<>()[\]{}"'`]+)(?:\.[^\s<>()[\]{}"'`]+)*(?:\?(?:[^\s<>()[\]{}"'`]+))*(?:#(?:[^\s<>()[\]{}"'`]+))?/gi;

  // 替换逻辑：将匹配到的链接转为<a>标签
  const htmlText = messageText.replace(urlRegex, (match) => {
    // 补全链接前缀（确保href属性是完整的可访问链接）
    let fullUrl = match;
    if (fullUrl.startsWith('www.')) {
      fullUrl = `https://${fullUrl}`;
    }

    // 生成超文本标签，保留原链接作为显示文本，添加配置项
    return `<a href="${fullUrl}" target="${target}" class="${className}">${match}</a>`;
  });

  return `<span style="
           whiteSpace: pre-line;
          wordBreak: 'break-all;
           wordWrap: 'break-word"
       >${htmlText}</span>`
}


// 对象数组按照某一元素排序
export const sortByProperty = (arr, property) => {
  arr.sort(function (a, b) {
    if (a[property] < b[property]) {
      return -1
    } else if (a[property] > b[property]) {
      return 1
    }
    return 0
  })
}

// 获取URL参数
/* export const getQueryParam = (param) =>{
 const urlParams = new URLSearchParams(window.location.href);
 return urlParams.get(param);
 } */

/* export const getQueryParam = (param) =>{
 const queryString = window.location.search.substring(1);
 const params = queryString.split('&');
 for (let i = 0; i < params.length; i++) {
 const pair = params[i].split('=');
 if (decodeURIComponent(pair[0]) === param) {
 return decodeURIComponent(pair[1]);
 }
 }
 return null;
 } */

export const getQueryParam = param => {
  const regex = new RegExp('[?&]' + param + '=([^&#]*)')
  const results = regex.exec(window.location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

/** 判断文字是否需要加密处理 */
export const nameIsEncrypt = str => {
  const appStore = useAppStore()
  const { audienceInfoEncrypt } = appStore.getConfig
  return audienceInfoEncrypt === 1 ? getEncryptStr(getNumberToStar(str), 1) : getNumberToStar(str)
}

// 正则表达式：中文、英文、数字、基础标点、基础特殊字符、空格
export const validateString = str => {
  // 基本汉字及扩展区
  const chineseChars =
    '\\u4E00-\\u9FFF\\u3400-\\u4DB5\\uF900-\\uFA6D\\u{20000}-\\u{2A6DF}\\u{2A700}-\\u{2B739}\\u{2B740}-\\u{2B81D}\\u{2B820}-\\u{2CEA1}\\u{2CEB0}-\\u{2EBE0}\\u{30000}-\\u{3134A}'
  // 拉丁字母和数字
  const latinAndDigits = 'A-Za-z0-9'
  // 标点符号
  const punctuation =
    '\\u3000-\\u303F\\u201C\\u201D\\uFF00-\\uFFEF\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E\\u2014\\u2015\\u2026\\u2018\\u2019\\u00B7'

  const forbiddenEmojis = [...emojiName]
  // 1. 转义禁止表情符号中的特殊字符
  const escapedEmojis = forbiddenEmojis.map(emoji => emoji.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  // 2. 构建禁止表情符号的正则表达式（负向先行断言）
  const forbiddenPattern = escapedEmojis.length > 0 ? '(?![^]*?(?:' + escapedEmojis.join('|') + '))' : ''

  // 主要字符组合
  const combined = `${chineseChars}${latinAndDigits}${punctuation}`
  const regex = new RegExp(`^${forbiddenPattern}[${combined}]*$`, 'u')
  return regex.test(str)
  // 这是过滤掉不符合输入的文本
  // const regex = new RegExp(`[${combined}]`, 'gu')
  // return str.match(regex)?.join('') || ''
}

export const capturePageToCanvas = (options = {}, callback) => {
  const defaultOptions = {
    format: 'image/png',
    quality: 0.3,
    scrollIntoView: true
  }

  const opts = { ...defaultOptions, ...options }

  // 使用html2canvas库实现页面截图
  // 需要先引入html2canvas库: https://html2canvas.hertzen.com/
  if (typeof html2canvas === 'undefined') {
    console.error('html2canvas is not loaded. Please include html2canvas library first.')
    return
  }

  // 获取要截图的元素，默认是整个body
  const element = document.documentElement

  if (opts.scrollIntoView) {
    element.scrollIntoView()
  }

  // 使用html2canvas进行截图
  html2canvas(element, {
    scale: 1, // 缩放比例，1表示不缩放
    logging: false, // 不输出日志信息
    useCORS: true, // 尝试加载跨域图片
    allowTaint: true, // 允许污染画布
    scrollX: 0,
    scrollY: 0,
    windowWidth: document.documentElement.scrollWidth,
    windowHeight: document.documentElement.scrollHeight,
    ignoreElements: e => {
      if (e.tagName === 'DIV' && e?.id === 'more') {
        return true
      }
      return false
    }
  })
    .then(canvas => {
      console.log('canvas:', canvas)
      // 将canvas转换为图片数据URL
      const imageData = canvas.toDataURL(opts.format, opts.quality)
      if (typeof callback === 'function') {
        callback(imageData)
      }
    })
    .catch(error => {
      callback('error')
    })
}

export const getBase64ImageSize = base64String => {
  // 1. 去除Base64前缀（如"data:image/png;base64,"）
  const base64Data = base64String.split(',')[1]

  // 2. 计算Base64字符串的实际字节大小
  // Base64编码会使数据大小增加约33%，所以计算公式为：
  // 字节大小 = (base64字符串长度 * 3/4) - 填充字符数
  const padding = base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0
  const sizeInBytes = (base64Data.length * 3) / 4 - padding

  return sizeInBytes
}

/** 获取json解析数据 */
import JSZip from 'jszip'
export const getJson = async (url) => {
  console.log('buffer_', url)
  return fetch(url)
    .then(res => {
      if (!res.ok) {
        throw new Error('Network response was not ok ' + res.statusText)
      }
      return res.arrayBuffer() // 获取二进制数据
    })
    .then(async buffer => {
      const zip = new JSZip()
      const _zip = await zip.loadAsync(buffer)
      for (const fileName in _zip.files) {
        const file = _zip.files[fileName]
        if (!file.dir) {
          const content = await file.async('string')
          console.log('Buffer_contentss', content)
          let content_json = JSON.parse(content)
          console.log('Buffer_content', content_json)
          if(url.includes('product.json')) {
            console.log('zipss', content_json, url)
          }
          return content_json
        }
      }
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error)
    })
}
